import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardContentComponent } from './dashboard-content/dashboard-content.component';
import { ShowResultComponent } from './show-result/show-result.component';
import { SvppMainComponent } from './svpp-main/svpp-main.component';

const routes: Routes = [

  {
    path: '',
    component: SvppMainComponent,
    children: [
      {
        path: 'result',
        component: ShowResultComponent,
      },
      {
        path: 'dashboard_content',
        component: DashboardContentComponent,
      },
      {
        path: '',
        component: DashboardContentComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class SvppRoutingModule { }
